import React from 'react'
import { Typography, Stack, Card, Button, Box, Dialog, DialogTitle, DialogActions, DialogContentText, DialogContent, List, ListItem, ListItemText } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { blue, grey } from '@mui/material/colors'
import { AppHeader } from 'components/app'
import titleIconPng from 'assets/titleIcon.png'
import HouseIcon from '@mui/icons-material/House'


export const Top = () => {
  const [open, setOpen] = React.useState(false)
  const [category, setCategory] = React.useState<'manual' | 'privacy'>('manual')
  const navigate = useNavigate()

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = (category: 'manual' | 'privacy') => {
    setCategory(category)
    setOpen(true)
  }

  return (
    <Stack direction={'column'} alignItems="center" sx={{backgroundColor: 'white'}} minHeight={'100dvh'}>
      <AppHeader />

      <Stack
        component={Card}
        elevation={2}
        width={'80%'}
        minWidth={600}
        maxWidth={1020}
        px={5}
        pt={0}
        pb={5}
        my={4}
        sx={{
          backgroundColor: grey[50],
          position: 'relative',
        }}
        direction={'column'}
        alignItems={'center'}
        spacing={5}
      >
        <Box position={'absolute'} left={10} top={10}>
          <img src={titleIconPng} height={100} style={{objectFit: 'contain', cursor: 'pointer'}} />
        </Box>

        <Typography variant='h5' align='center' fontWeight={'bold'} color={grey[700]} whiteSpace={'pre-wrap'} sx={{textShadow: '1px 1px 1px rgba(0, 0, 0, 0.3)'}}>
          {'ResReal 水害リスク自己査定システム'}
        </Typography>

        <Typography variant='body1' align='center' maxWidth={640} color={grey[900]}>
          {'ResReal水害レジレジリエンスの自己査定が行えるシステムです。手順にしたがって入力することで、水害レジリエンス認証ランクの確認が可能になります。なお、自己査定にあたっては以下の「注意事項」を必ずご確認いただきますようお願いいたします。'}
        </Typography>

        { false && <Button variant='outlined' onClick={() => handleOpen('manual')}>詳しい利用方法を確認する</Button> }

        <Stack maxWidth={640}>
          <Typography variant='body1' align='center' fontWeight={'bold'} color={grey[700]} mb={2}>注意事項</Typography>
          <ul style={{lineHeight: 1.6, padding: '0 0 0 20px', margin: 0, fontSize: '0.875rem', color: grey[700]}}>
            <li style={{paddingBottom: 6}}>本システムの利用を通じて（一財）日本不動産研究所に提供された情報は<u style={{color: blue[700], cursor: 'pointer'}}><a onClick={() => handleOpen('privacy')}>プライバシーポリシー</a></u>に則り、取り扱いに十分配慮するものとします。</li>
            <li style={{paddingBottom: 6}}>本システムは、<b><u>概ねの認証ランクを確認する</u></b>ことを目的として自己査定を行うものです。認証機関である（一財）日本不動産研究所がその内容を保証するものではありません。</li>
            <li style={{paddingBottom: 6}}>自己査定システムにおける最大浸水深については、以下の理由により、正式な認証時の評価では評価グレードが変わる可能性があります。</li>
          </ul>
          <ul style={{lineHeight: 1.6, padding: '0 0 0 40px', margin: 0, fontSize: '0.875rem', color: grey[700]}}>
            <li style={{paddingBottom: 6}}>外水については、「浸水ナビ」「東京都浸水予想図」の情報を利用し、こちらのサイトに掲載されていない場合、水害リスク算定から除外されます。</li>
            <li style={{paddingBottom: 6}}>内水については、(株)建設技術研究所提供の内水リスクマップを利用し、自治体が公表している内水ハザードマップの情報は加味されておりません。</li>
            <li style={{paddingBottom: 6}}>実際の認証時評価では自治体で公開されているすべてのマップで評価を実施します。</li>
          </ul>
          <ul style={{lineHeight: 1.6, padding: '0 0 0 20px', margin: 0, fontSize: '0.875rem', color: grey[700]}}>
            <li style={{paddingBottom: 6}}>本システムで入力した項目の中には定量的・機械的に判断可能な項目を除き、認証機関が調査等を経て判断する項目が一定数ありますが、本システムではその判断を一切行っておりません。したがって、入力された通りに評価いたしますので、<b><u>正式な認証申し込みの際は異なる結果になる可能性があります。</u></b></li>
            <li style={{paddingBottom: 6}}>本システムの結果を第三者に開示したり、各種掲載物などに掲載することはお控えください。それによって生じたいかなる損害も当方では責任を負いかねますのでご了承ください。</li>
          </ul>
        </Stack>

        <Button variant='contained' startIcon={<HouseIcon />} size='large' onClick={() => navigate('/0', {replace: false})}>自己査定を開始する</Button>
      </Stack>

      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle align='center'>
          { category === 'manual' ? 'ご利用方法' : 'プライバシーポリシー' }
        </DialogTitle>
        <DialogContent>
          { category === 'manual' && (
            <ol>
              <li>
                トップページ内の開始ボタンからアクセスし、スコアリングを入力してください。ログインは不要です。ただし、一時保存機能により、途中離脱、再回答、他のパソコン、ユーザーへの引き継ぎなどが可能です。離脱（一時保存）したい場合は「一時保存」を押してください。暗号キー付き URL が表示されますので、こちらを保管してください。
                <br />※複数による同時入力はできません。
              </li>
              <li style={{marginTop: 10}}>
                再回答する場合は、暗号キー付き URL にアクセスしてください。前回の結果が表示されますので、引き続き回答してください。
                <br />※一時保存は何度でも利用可能です。
              </li>
              <li style={{marginTop: 10}}>
                入力した回答結果をダウンロードしたい場合は「保存する」ボタンを押してください。エクセルがダウンロードされます。こちらを認証時に活用頂くこともできます。
              </li>
            </ol>
          )}
          { category === 'privacy' && (
            <Stack>
              <Typography>（個人情報の利用目的等に関する表示）</Typography>
              <Typography>認証機関である一般財団法人日本不動産研究所が当該自己査定システムのご利用によって取得する個人情報の利用目的は以下のとおりです。</Typography>
              <ul>
                <li>不動産レジリエンス認証に関する各種情報の提供・連絡</li>
                <li style={{marginTop: 10}}>
                  当該自己査定システムの利用状況のモニタリング
                </li>
                <li style={{marginTop: 10}}>
                  当該自己査定システムにて入力して頂いた情報は、不動産レジリエンス認証の運営に関連した上記の目的に限り利用させていただきます。
                  これ以外の場合においてご本人の許可なく第三者へ情報公開することはありません。
                  なお、個人情報保護法第24条第1項に定める事項については、<a href='https://www.reinet.or.jp/' target='_blank' rel="noreferrer">一般財団法人日本不動産研究所</a>をご覧ください。
                </li>
              </ul>
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  )
}
